'use client'

import { IconButtonProps, IconButton, styled } from '@mui/material'
import React, { memo } from 'react'
import ArrowLeft from '@assets/arrow-left.svg'

const RoundButton = styled(IconButton)({
  backgroundColor: 'var(--dewi_colors_gray_8) !important',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
})

export type BackButtonProps = IconButtonProps

const BackButton = ({ ...rest }: BackButtonProps) => {
  return (
    <RoundButton {...rest}>
      <ArrowLeft />
    </RoundButton>
  )
}

export default memo(BackButton)
